import React, { createContext, useState, useContext, ReactNode } from 'react';
import { TileData, SeaObjectType } from '../types/treasure-hunt';
import { GRID_ROWS, GRID_COLS } from '../constants/treasure-hunt';

interface TreasureHuntContextType {
  tileMap: TileData[][];
  setTileMap: (map: TileData[][]) => void;
  resetTileMap: () => void;
}

const TreasureHuntContext = createContext<TreasureHuntContextType | undefined>(undefined);

interface TreasureHuntProviderProps {
  children: ReactNode;
}

const createInitialMap = (): TileData[][] => {
  const map: TileData[][] = [];
  for (let y = 0; y < GRID_ROWS; y++) {
    map[y] = [];
    for (let x = 0; x < GRID_COLS; x++) {
      map[y][x] = { tileCode: SeaObjectType.WATER };
    }
  }
  return map;
};

export const TreasureHuntProvider: React.FC<TreasureHuntProviderProps> = ({ children }) => {
  const [tileMap, setTileMap] = useState<TileData[][]>(createInitialMap);

  const resetTileMap = () => {
    setTileMap(createInitialMap());
  };

  return (
    <TreasureHuntContext.Provider value={{ tileMap, setTileMap, resetTileMap }}>
      {children}
    </TreasureHuntContext.Provider>
  );
};

export const useTreasureHunt = (): TreasureHuntContextType => {
  const context = useContext(TreasureHuntContext);
  if (!context) {
    throw new Error('useTreasureHunt должен использоваться внутри TreasureHuntProvider');
  }
  return context;
};
